import {Component, Input, OnInit} from '@angular/core';
import {PlacementTestSectionModel} from '../../../../../models/edu-admin/placement-test.model';
import {SectionResult} from '../../placement-group-view.component';
import {AssetsHelper} from '../../../../../models/extensions/assets-helper.model';

@Component({
  selector: 'app-placement-group-section-card-small',
  templateUrl: './placement-group-section-card-small.component.html',
  styleUrls: ['./placement-group-section-card-small.component.css']
})
export class PlacementGroupSectionCardSmallComponent implements OnInit {

  @Input() index = 1;
  @Input() numStudents = 0;
  @Input() placementSection: PlacementTestSectionModel;
  @Input() sectionResult: SectionResult;

  constructor() { }

  ngOnInit() {
  }

  categoryIcon(): string {
    return AssetsHelper.categoryIconURL(this.placementSection.category);
  }

  avgMasteryForSection(): string {

    if (this.sectionResult) {
      return this.sectionResult.avgSkillMasteryForSection(this.numStudents);
    }

    return '0';
  }

  numSkillsInSection(): string {

    if (this.placementSection) {
      return this.placementSection.orderedQuestions.length.toString(10);
    }

    return '0';
  }
}
